import { parseConfig } from '@office-start/config-parser-utility';
var featureSettingsKey = 'featureSettings';
export function readFeatureSettings() {
    var domFeatureSettings = parseConfig(featureSettingsKey);
    return domFeatureSettings;
}
//# sourceMappingURL=readFeatureSettings.js.map